/* istanbul ignore file */
import React from 'react';
import Dropdown from './Dropdown';
import { DefaultDropdownProps } from './dropdownHelper';
import { COUNTRIES } from './CountryConstants/constants';

export const getCountryEmoji = (countryName?: string) => {
  const country = COUNTRIES.find(selectedCountry => selectedCountry.name === countryName);
  return country ? country.emoji : 'N/A';
};

const buildCountries = (priorityCountries?: string[]) => {
  if (!priorityCountries?.length) return COUNTRIES;

  const prioritySet = new Set(priorityCountries);

  const priority = COUNTRIES.filter(c => prioritySet.has(c.code) || prioritySet.has(c.name));

  const rest = COUNTRIES.filter(c => !prioritySet.has(c.code) && !prioritySet.has(c.name));

  return [...priority, ...rest];
};

/**
 * Component is used to display dropdown with US states.
 *
 * @param props
 * @returns {*}
 * @constructor
 */
const CountryDropdown = ({ priorityCountries, ...props }: DefaultDropdownProps & { priorityCountries?: string[] }) => {
  const countries = buildCountries(priorityCountries);

  return (
    <Dropdown
      placeholder="Select country"
      options={countries.map(state => ({
        value: state.name,
        label: state.name,
      }))}
      {...props}
    />
  );
};

export default CountryDropdown;
